import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

const ApiURL = process.env.REACT_APP_API_URL;
const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
  apiCode: process.env.REACT_APP_API_CODE,
  "agent-referrer": document.referrer,
  "agent-service": localStorage.getItem("agent_service"),
};

class Api {
  Get(url) {
    return axios.get(ApiURL + url, {
      headers: { ...headers, Authorization: Cookies.get("token") || null },
    });
  }
  Post(url, data) {
    const tokenCookie = Cookies.get("token");
    const newHeaders = tokenCookie
      ? { ...headers, Authorization: tokenCookie }
      : { ...headers };

    return axios
      .post(ApiURL + url, data, {
        headers: newHeaders,
      })
      .catch((error) => {
        toast.error(error?.response?.data?.Message);
        throw error;
      });
  }
  RefreshToken(error) {
    return this.Post("user/refresh/token", {
      mobile: localStorage.getItem("mobile"),
      refreshToken: Cookies.get("refreshToken"),
      agentString: "",
    })
      .then((res) => {
        window.location.reload();
        Cookies.set("token", res.data.Data.token);
        Cookies.set("refreshToken", res.data.Data.refreshToken);
        error.config.headers.Authorization = res.data.Data.token;
        return axios.request(error.config);
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          console.log("refreshToken", err.response.status);
          window.location = "/logout";
        }
        return Promise.reject(error);
      });
  }
  ShowError(error) {
    return toast.success(this.ErrorHandler(error));
  }
  ErrorHandler(error) {
    let message = "";
    switch (error) {
      case 403:
        message = "شما دسترسی به این قسمت ندارید";
        break;
      case 404:
        message = "داده مورد نظر یافت نشد";
        break;
      case 402:
        message = "مشکلی رخ داده ، لطفا ان را گزارش دهید";
        break;
      case 400:
        message = "مشکلی رخ داده ، ورودی های خود را بررسی کنید";
        break;
      case 500:
        message = "مشکلی رخ داده ، دوباره تلاش کنید";
        break;
      case 503:
        message = "مشکلی رخ داده ، دوباره تلاش کنید";
        break;
      case 401:
        message = "شما دسترسی به این قسمت را ندارید";
        break;
      default:
        message = "مشکلی رخ داده است";
        break;
    }
    return message;
  }
}
const ApiClass = new Api();
export default ApiClass;

var tryCount = 0;
axios.interceptors.response.use(null, (error) => {
  if (error.config && error.response) {
    if (error.response.status === 401) {
      if (tryCount === 1) return Promise.reject(error);
      tryCount++;
      ApiClass.RefreshToken();
    }
  }

  return Promise.reject(error);
});
